<i18n src="@/lang/actions.json" />

<template>
  <el-main>
    <draggable-element v-model="data.data" :available-icons="icons" />
    <el-row
      type="flex"
      justify="end"
      style="background-color: #ffffff; padding: 30px"
    >
      <el-button
        icon="el-icon-plus"
        :loading="adding"
        @click="handleAddNewRow"
        >{{ $t("actions.add_new") }}</el-button
      >
      <el-button
        icon="el-icon-upload"
        :loading="loading"
        @click="handleSaveData"
        >{{ $t("actions.save") }}</el-button
      >
    </el-row>
  </el-main>
</template>

<script>
import MenuEditorList from "../../store/classes/MenuEditor/MenuEditorList";
import DraggableElement from "./elements/draggable-element";
import { mapActions } from "vuex";

export default {
  name: "menu-editor",
  components: { DraggableElement },
  data: () => ({
    data: [],
    icons: [],
    value: undefined,
    loading: false,
    adding: false
  }),
  created() {
    this.init();
    window.mel = MenuEditorList;
  },
  methods: {
    ...mapActions("cache/shared_menu", ["loadData", "saveData"]),
    async init() {
      this.data = await MenuEditorList.selfInitFromLoadedData();
      this.icons = this.getIcons();
    },
    getIcons() {
      let icons = [];
      // for (let v of process.env.NODE_ENV === "production"
      //   ? [...document.getElementsByTagName("link")].find(
      //       v => v.rel === "stylesheet" && /\/?app(\..+)?\.css$/.test(v.href)
      //     ).sheet.cssRules
      //   : document.styleSheets[0].cssRules) {
      //   if (/el-icon-[\w-]+:+before\W?\{\W?content:[^}]+\}/i.test(v.cssText)) {
      //     icons.push(v.selectorText.slice(1).split(":")[0]);
      //   }
      // }
      for (let v of document.styleSheets[0].cssRules) {
        if (/el-icon-[\w-]+:+before\W?\{\W?content:[^}]+\}/i.test(v.cssText)) {
          icons.push(v.selectorText.slice(1).split(":")[0]);
        }
      }
      return icons.map(item => {
        return { value: item, label: item.replace(/^el-icon-/, " ") };
      });
    },
    async handleAddNewRow() {
      this.adding = true;
      this.data.addNewChildren();
      await this.$nextTick();

      let res = await this.saveData(this.data.getRawData());
      this.data = await MenuEditorList.selfInitFromLoadedData(res);

      this.adding = false;
    },
    async handleSaveData() {
      this.loading = true;

      let res = await this.saveData(this.data.getRawData());
      this.data = await MenuEditorList.selfInitFromLoadedData(res);

      this.loading = false;
    }
  }
};
</script>

<style scoped lang="stylus"></style>
